import { render, staticRenderFns } from "./ListagemProcessosLicitacao.vue?vue&type=template&id=0098a4db&scoped=true&"
import script from "./ListagemProcessosLicitacao.vue?vue&type=script&lang=js&"
export * from "./ListagemProcessosLicitacao.vue?vue&type=script&lang=js&"
import style0 from "./ListagemProcessosLicitacao.vue?vue&type=style&index=0&id=0098a4db&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098a4db",
  null
  
)

export default component.exports